
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import ModalWrapper from '~/components/common/modals/basic/ModalWrapper.vue'
import RadioSet from '~/components/common/input/RadioSet.vue'
import TextArea from '~/components/common/input/TextArea.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import Icon from '~/components/common/icon/Icon.vue'

interface SurveyOption {
  allowDetails: boolean;
  id: string;
  links: { self: string };
  self: string;
  sort: number;
  title: string;
  type: string;
}

@Component({
  components: {
    ModalWrapper,
    RadioSet,
    TextArea,
    DashboardButton,
    Icon
  },
  computed: {
    ...mapState('engagementModal', ['options'])
  }
})
export default class NoEngagementSurvey extends Vue {
  @Prop({ type: String, default: undefined }) scholarshipId: string

  selected: SurveyOption | {} = {}
  text = ''
  isSending = false

  created() {
    this.$store.dispatch('engagementModal/getOptions')
  }

  submit() {
    this.isSending = true

    const params: { scholarshipId: string; optionId: string; details?: string } = {
      scholarshipId: this.scholarshipId,
      optionId: (this.selected as SurveyOption).id
    }

    if ((this.selected as SurveyOption).allowDetails) {
      params.details = this.text
    }

    this.$store.dispatch('engagementModal/postOption', params)
      .then(() => {
        this.$notyf.success(('Your answer was successfully sent.'))
        this.$emit('close')
        this.isSending = false
      })
      .catch((err) => {
        this.$notyf.error('Something went wrong. Please try letter.')
        this.$sentry.captureException(err)
        this.isSending = false
      })
  }

  dontShowHandler() {
    this.$store.dispatch('engagementModalBehavior/changeSessionAppearingCondition', false)
    this.$emit('close')
  }
}
